import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_tooltip.scss'

import { PlacementNS, Props, SpanAttributes } from '../utils/types'
import addSubcomponents from '../utils/addSubcomponents'
import { OverlayTriggerAdapter as OverlayTrigger } from './OverlayTriggerAdapter'
import { OverlayTriggerPlacement } from '../state/OverlayTrigger'

export interface TooltipProps extends Props {
  initialIsVisible?: boolean
  overlay?: any
  placement?: OverlayTriggerPlacement
  children: React.ReactElement
}

export interface TooltipContentProps extends Props {
  placement?: OverlayTriggerPlacement
}

const cx = bind(styles)

export const Tooltip = ({
  children,
  initialIsVisible = false,
  overlay,
  placement = PlacementNS.top,
  ...props
}: TooltipProps) => {
  const overlayNode =
    typeof overlay === 'string' ? (
      <Content placement={placement}>{overlay}</Content>
    ) : (
      React.cloneElement(overlay, { placement })
    )

  return (
    <OverlayTrigger
      overlay={overlayNode}
      placement={placement}
      initialIsVisible={initialIsVisible}
      {...props}
    >
      {children}
    </OverlayTrigger>
  )
}

export const Content = React.forwardRef<
  HTMLSpanElement,
  SpanAttributes & TooltipContentProps
>(({ children, className, placement = PlacementNS.top, ...props }, ref) => (
  <span ref={ref} className={cx('core-tooltip__container')}>
    <span
      className={cx('core-tooltip', `core-tooltip--${placement}`, className)}
      {...props}
    >
      {children}
    </span>
  </span>
))

Content.displayName = 'Tooltip.Content'

export default addSubcomponents(
  {
    Content,
  },
  Tooltip
)
